module.exports = __webpack_public_path__ + "static/img/contentRightImg6.8c95218.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentRightImg6.png
// module id = 7xmI
// module chunks = 2